// interfaces
import { Language } from "../interfaces/language/language.interface";
import { PlayerAudio } from "../interfaces/player/player.interface";


export const languages = [
    "en-US",
    "es-ES",
    "fr-FR",
    "fr-CA",
    "fr-BE",
    "fr-CH",
    "en-IN",
    "en-GB",
    "hi-IN",
    "nl-NL",
    "se-SE",
    "dk-DK",
    "de-DE",
    "de-AT",
    "fi-FI",
    "it-IT",
]

export const languageDescriptions: Language[] = [
    {
        code: "en-US",
        description: "English (US)"
    },
    {
        code: "es-ES",
        description: "Español"
    },
    {
        code: "fr-FR",
        description: "Français"
    },
    {
        code: "fr-CA",
        description: "Français (Canadien)"
    },
    {
        code: "fr-BE",
        description: "Français (Belgique)"
    },
    {
        code: "fr-CH",
        description: "Français (Suisse)"
    },
    {
        code: "en-IN",
        description: "English (India)"
    },
    {
        code: "en-GB",
        description: "English (UK)"
    },
    {
        code: "hi-IN",
        description: "Hindi"
    },
    {
        code: "nl-NL",
        description: "Netherlands"
    },
    {
        code: "se-SE",
        description: "Svenska"
    },
    {
        code: "dk-DK",
        description: "Dansk"
    },
    {
        code: "de-DE",
        description: "Deutsch"
    },
    {
        code: "de-AT",
        description: "Deutsch (Österreich)"
    },
    {
        code: "fi-FI",
        description: "Suomi"
    },
    {
        code: "it-IT",
        description: "Italiano"
    },
]

export const getFlagCode = (code: string) => {
    if (typeof code !== 'undefined') {
        if (code === "en-US") return "us";
        if (code === "en-GB") return "gb";
        if (code === "en-IN") return "in";
        if (code === "hi-IN") return "in";
        if (code === "nl-NL") return "nl";
        if (code === "fr-CA") return "ca";
        if (code === "fr-BE") return "be";
        if (code === "fr-CH") return "ch";
        if (code === "de-AT") return "at";
        else return code.substring(0, 2);
    } else {
        return "undefined";
    }
}

export const getAllLanguageDescriptionsFromAudios = (audioQueue: PlayerAudio[]): Language[] => {

    let availableLanguages: Language[] = [];

    for (const audio of audioQueue){

        let articleLanguageFound: boolean = false;
        let i: number = 0;
        while (!articleLanguageFound && i < languageDescriptions.length){

            if (audio.language === languageDescriptions[i].code){
                if (!availableLanguages.includes(languageDescriptions[i])){
                    availableLanguages.push(languageDescriptions[i]);
                }
                articleLanguageFound = true;
            }
            i++;
        }

        while (!articleLanguageFound && i < languageDescriptions.length){
            if (audio.language === languageDescriptions[i].code){
                if (!availableLanguages.includes(languageDescriptions[i])){
                    availableLanguages.push(languageDescriptions[i]);
                }
                articleLanguageFound = true;
            }
            i++;
        }
    }

    return availableLanguages;
}
